const SUPERVISOR_DEFAULT_ROUTE = '/sales'

const SUPERVISOR_ALLOWED_ROUTES = [
  'help-center',
  'search',
  'sales',
  'sale-details',
  'returns',
  'productsreport',
  'agents',
  'closing',
  'products',
  'customers',
  'customer-statements',
  'statement-detail',
  'stock',
  'stock-movements',
  'stock-alerts',
  'batches',
  'new-batche',
  'batch-details',
  'restaurant-tables',
  'table-detail',
  'restaurant-orders',
  'order-detail',
  'restaurant-servers',
  'restaurant-commissions',
  'supervisor-codes',
  'ingredients',
  'compositions',
  'ingredient-movements',
  'ingredient-stock',
  'ingredient-alerts',
  'ingredients-report',
  'rates',
  'users',
]

const SUPERVISOR_ALLOWED_LINKS = [
  '/aide',
  '/search',
  '/sales',
  '/returns',
  '/productsreport',
  '/agents',
  '/closing',
  '/products',
  '/customers',
  '/stock',
  '/stock-movements',
  '/stock-alerts',
  '/batches',
  '/new-batche',
  '/restaurant/tables',
  '/restaurant/orders',
  '/restaurant/servers',
  '/restaurant/commissions',
  '/restaurant/codes',
  '/ingredients',
  '/compositions',
  '/ingredient-movements',
  '/ingredient-stock',
  '/ingredient-alerts',
  '/ingredients-report',
  '/rates',
  '/users',
]

function normalizeRoleName(roleName) {
  return String(roleName || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

export function getSupervisorDefaultRoute() {
  return SUPERVISOR_DEFAULT_ROUTE
}

export function getAuthenticatedUser() {
  try {
    const auth = JSON.parse(localStorage.authentication || '{}')
    return auth.user || null
  } catch (_) {
    return null
  }
}

export function getAuthenticatedRoleName() {
  const user = getAuthenticatedUser()
  return user && user.role ? user.role.name : ''
}

export function isSupervisorRole(roleName) {
  const normalizedRole = normalizeRoleName(roleName)
  return normalizedRole === 'superviseur' || normalizedRole === 'supervisor'
}

export function isCurrentUserSupervisor() {
  return isSupervisorRole(getAuthenticatedRoleName())
}

export function isCashierRole(roleName) {
  const normalizedRole = normalizeRoleName(roleName)
  return normalizedRole === 'caissier' || normalizedRole === 'cashier'
}

export function isAdminRole(roleName) {
  const normalizedRole = normalizeRoleName(roleName)
  return normalizedRole === 'administrateur' || normalizedRole === 'admin' || normalizedRole === 'administrator'
}

export function isCurrentUserAdmin() {
  return isAdminRole(getAuthenticatedRoleName())
}

// Pages réservées au rôle Administrateur du business (ex. credentials KL Pay).
const ADMIN_ONLY_ROUTES = ['klpay/settings']
const ADMIN_ONLY_LINKS = ['/klpay/settings']

export function canCurrentUserAccessRoute(routeName) {
  if (ADMIN_ONLY_ROUTES.includes(routeName)) return isCurrentUserAdmin()
  if (!isCurrentUserSupervisor()) return true
  return SUPERVISOR_ALLOWED_ROUTES.includes(routeName)
}

export function canCurrentUserAccessLink(link) {
  if (ADMIN_ONLY_LINKS.includes(link)) return isCurrentUserAdmin()
  if (!isCurrentUserSupervisor()) return true
  return SUPERVISOR_ALLOWED_LINKS.includes(link)
}
